import { z, toJSONSchema } from 'zod';
import Cookies from 'js-cookie';
import { TENANT_STORAGE_KEY } from '@constants/tenant';
import { CartService } from '@services/cart';
import { useServiceRef } from 'hooks/useServiceRef';
import { McpService } from '../mcp';
import { InputSchema, ToolDescriptor, ToolResponse } from '@mcp-b/webmcp-types';

const schema = z.object({
  lineItemId: z.string()
    .describe('The ID or IDs of the line item to remove from the cart.'),
  quantity: z.number().describe('The quantity of the line item to remove from the cart.')
});

export const changeCartItemQuantityTool: ToolDescriptor<z.infer<typeof schema>, ToolResponse> = {
  name: 'change_cart_item_quantity',
  description: `Change the quantity of a line item in the current user's cart. Schema: ${JSON.stringify(schema.shape)}`,
  inputSchema: toJSONSchema(schema) as InputSchema,
  execute: async ({ lineItemId, quantity }: z.infer<typeof schema>): Promise<ToolResponse> => {
    const cartServiceRef = useServiceRef(CartService);
    const mcpServiceRef = useServiceRef(McpService);

    const tenantKey = JSON.parse(Cookies.get(TENANT_STORAGE_KEY) || null)?.key;
    let cart = await cartServiceRef.current.getMyActiveCart(tenantKey);

    cart = await cartServiceRef.current.changeLineItemQuantity(
      cart.id,
      cart.version,
      lineItemId,
      quantity
    );

    if (cart) {
      mcpServiceRef.current.triggerCartUpdate(cart);
    }

    return {
      content: [ {
        type: 'text',
        text: `Updated cart with ${
          cart?.lineItems?.length || 0
        } items and total price of ${cart?.totalPrice?.value || 0}. Cart: ${JSON.stringify(cart)}.`,
      } ]
    };
  }
};
